module.exports = __webpack_public_path__ + "img/about1.d34373cf.png";